import React from 'react';
import ProductCardList from '../ProductCardList';
import { ProductCardProps } from '../ProductCard';
import cx from 'classnames';

import TextActionAccordion from '../TextActionAccordion';

import styles from './index.module.scss';

export interface ProductCardListActionAccordionProps {
  activeStateTagText?: string;
  number: string;
  title: string;
  subtitle?: string;
  text?: string;
  isOpenByDefault?: boolean;
  leftButtonText?: string;
  buttonOnClick?: () => void;
  isButtonLoading?: boolean;
  leftButtonError?: object;
  completed: boolean;
  rightButtonText?: string;
  rightButtonUrl?: string;
  contentLinkText?: string;
  contentLinkUrl?: string;
  className?: string;
  productList: ProductCardProps[];
  isSingleSelect?: boolean;
  urlAttributes?: string;
  isLocked?: boolean;
}

const ProductCardListActionAccordion: React.FC<
  ProductCardListActionAccordionProps
> = ({
  activeStateTagText,
  number,
  title,
  subtitle,
  text,
  isOpenByDefault,
  leftButtonText,
  buttonOnClick,
  isButtonLoading,
  leftButtonError,
  completed,
  rightButtonText,
  rightButtonUrl,
  contentLinkText,
  contentLinkUrl,
  className,
  productList,
  isSingleSelect,
  isLocked,
  urlAttributes,
}) => {
  return (
    <div className={cx(styles.wrapper, className)}>
      <TextActionAccordion
        title={title}
        subtitle={subtitle}
        isOpenByDefault={isOpenByDefault}
        text={text}
        number={number}
        activeStateTagText={activeStateTagText}
        leftButtonText={leftButtonText}
        buttonOnClick={buttonOnClick}
        isButtonLoading={isButtonLoading}
        leftButtonError={leftButtonError}
        completed={completed}
        rightButtonText={rightButtonText}
        rightButtonUrl={rightButtonUrl}
        contentLinkText={contentLinkText}
        contentLinkUrl={contentLinkUrl}
      >
        <ProductCardList
          list={productList}
          className={styles.productCardList}
          isSingleSelect={isSingleSelect}
          isLocked={isLocked}
          urlAttributes={urlAttributes}
        />
      </TextActionAccordion>
    </div>
  );
};

export default ProductCardListActionAccordion;
